module.exports = __webpack_public_path__ + "img/eighth.902bee34.png";